// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/collision-avoidance-scanning.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/collision-avoidance-scanning/collision-avoidance-scanning.js';
import g1 from '../lessons/aeronautics/collision-avoidance-scanning/collision-blind-spots.js';

mount([g0, g1]);
